import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { toLocalAPIDate } from 'src/app/utils/date';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { TopHeaderService } from 'src/app/core/services/top-header/top-header.service';

@Component({
  selector: 'app-date-tab-selector',
  templateUrl: './date-tab-selector.component.html',
  styleUrls: ['./date-tab-selector.component.scss'],
})
/**
 * Date selector for timeline organism
 */
export class DateTabSelectorComponent implements OnInit {
  @Output() selectFilterClick = new EventEmitter<any>();
  businessRegisterDate?: Date;
  yearsOptions: number[] = [];
  yearControl = new FormControl();
  selectedMonthIndex: number = new Date().getMonth();

  months: string[] = [
    'JAN',
    'FEB',
    'MAR',
    'APR',
    'MAY',
    'JUN',
    'JUL',
    'AUG',
    'SEP',
    'OCT',
    'NOV',
    'DEC',
  ];

  labelsMonths = {
    jan: 'january-short',
    feb: 'february-short',
    mar: 'march-short',
    apr: 'april-short',
    may: 'may-short',
    jun: 'june-short',
    jul: 'july-short',
    aug: 'august-short',
    sep: 'september-short',
    oct: 'october-short',
    nov: 'november-short',
    dec: 'december-short',
  };

  /**
   * @constructor
   */
  constructor(
    private readonly translationService: TranslationService,
    private readonly topHeaderService: TopHeaderService
  ) {}

  /**
   * on init
   */
  ngOnInit(): void {
    this.yearControl.valueChanges.subscribe(() => {
      this.emitDateRange();
    });

    Promise.all([
      this.translationService.translateObject(this.labelsMonths),
      this.topHeaderService.fetchTopHeaderInfo(),
    ]).then(() => {
      this.months = Object.values(this.labelsMonths);
      this.businessRegisterDate = this.topHeaderService.business?.registerDate;
      this.initializeYearFilter();
    });
  }

  /**
   * Set tab filter
   * @param {MatTabChangeEvent} event
   */
  setTabFilter(event: MatTabChangeEvent) {
    this.selectedMonthIndex = event.index;
    this.emitDateRange();
  }

  /**
   * Method to emit a date range filter
   */
  private emitDateRange() {
    if (!this.yearControl.value) return;
    const year = this.yearControl.value;
    const month = this.selectedMonthIndex;

    const startDate = toLocalAPIDate(new Date(year, month, 1));
    const endDate = toLocalAPIDate(new Date(year, month + 1, 0, 23, 59, 59));

    const obj = {
      startDate,
      endDate,
    };

    this.selectFilterClick.emit(obj);
  }

  /**
   * Get list of year
   * @return {number[]}
   */
  generateYearFilter(): number[] {
    if (!this.businessRegisterDate) {
      return [];
    }
    const startYear = new Date(this.businessRegisterDate).getUTCFullYear();
    const currentYear = new Date().getFullYear();
    const years = [];

    for (let year = startYear; year <= currentYear; year++) {
      years.push(year);
    }

    return years.reverse();
  }

  /**
   * Method to initialize
   */
  private initializeYearFilter() {
    if (this.businessRegisterDate && this.yearsOptions.length === 0) {
      this.yearsOptions = this.generateYearFilter();
      const currentYear = new Date().getFullYear();

      this.yearControl.setValue(currentYear);
    }
  }
}
